<template>
  <div class="card shadow-sm border-0 rounded-4 h-100">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between flex-column align-items-start mb-1">
        <h6 class="text-uppercase text-muted fs-6 mb-0">Antigüedad</h6>
        <span class="badge rounded-pill px-3 py-1" :class="badgeClass">{{ label }}</span>
      </div>

      <h5 class="fw-semibold fs-5 mb-0">
        {{ quantity != null ? quantity : "—" }} {{ unit || "meses" }}
      </h5>
      <small class="text-muted d-block">Equivalente: {{ months }} meses</small>
      <small class="text-muted">Puntos: <strong>{{ computedPoints }}</strong> (1–5)</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "SeniorityCard",
  props: {
    quantity: { type: Number, default: null },       // cantidad numérica
    unit: { type: String, default: "meses" },        // "meses" | "años"
    points: { type: Number, default: 0 }             // v-model:points → 1–5
  },
  emits: ["update:points"],
  computed: {
    months() {
      const q = Number(this.quantity || 0);
      return this.unit === "años" ? q * 12 : q;
    },

    // Rangos DISCRETOS (1–5) según tu tabla
    computedPoints() {
      const m = Number(this.months);
      if (!Number.isFinite(m) || m < 0) return 1; // mínimo 1
      if (m > 60)  return 5;            // > 5 años
      if (m > 36)  return 4;            // 3–5 años
      if (m > 12)  return 3;            // 1–3 años
      if (m >= 6)  return 2;            // 6m – 1 año
      return 1;                         // < 6 meses
    },

    label() {
      const m = this.months;
      if (m > 60) return "> 5 años";
      if (m > 36) return "3–5 años";
      if (m > 12) return "1–3 años";
      if (m >= 6) return "6m – 1 año";
      return "< 6 meses";
    },
    badgeClass() {
      const p = this.computedPoints;
      if (p >= 4) return "bg-success-subtle text-success-emphasis";
      if (p === 3) return "bg-warning-subtle text-warning-emphasis";
      return "bg-danger-subtle text-danger-emphasis";
    }
  },
  watch: {
    computedPoints: {
      immediate: true,
      handler(val) {
        this.$emit("update:points", val);
      }
    }
  }
};
</script>

<style scoped>
.bg-success-subtle { background-color: rgba(25,135,84,.12) !important; }
.text-success-emphasis { color: #146c43 !important; }
.bg-warning-subtle { background-color: rgba(255,193,7,.15) !important; }
.text-warning-emphasis { color: #997404 !important; }
.bg-danger-subtle { background-color: rgba(220,53,69,.12) !important; }
.text-danger-emphasis { color: #842029 !important; }
</style>
  